/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {BaseInstance} from './base-instance';
import {Zone} from './zone';
import {LocationInstance} from './location-instance';
import {Point} from './point';
import {Color} from './color';

export class ZoneInstance extends BaseInstance {
  zone: Zone;
  locationInstance: LocationInstance;
  midPoint: Point;
  namePoint: Point;
  perimeterPoints: Point[];
  color: Color;
  textColor: Color;
}
